import { useHistory } from 'react-router-dom';

export const KEY: string = 'page';
const DEFAULT_PAGE_INDEX: number = 0;

type response = {
  pageIndex: number;
  searchParams: string | null;
};

/**
 * Get value of `page` search term from URLSearchParams.
 */
export const usePageSearchParam = (): response => {
  const history = useHistory();
  let updateSearchParam: boolean = false;

  const searchParams = new URLSearchParams(history.location.search);
  const page = searchParams.get(KEY) ?? DEFAULT_PAGE_INDEX.toString();

  if (searchParams.get(KEY) === null) {
    updateSearchParam = true;
  }

  let pageIndex: number = Number.parseInt(page);

  if (pageIndex <= DEFAULT_PAGE_INDEX || Number.isNaN(pageIndex)) {
    pageIndex = DEFAULT_PAGE_INDEX;
    updateSearchParam = true;
  }

  if (updateSearchParam) {
    searchParams.set(KEY, (pageIndex + 1).toString());
    history.push({ search: searchParams.toString() });
  }

  return {
    pageIndex: pageIndex - 1,
    searchParams: searchParams.toString(),
  };
};
